import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const reducedCss = ({ reduced }) =>
  reduced &&
  css`
    width: 350px;
    min-height: 100px;
    max-height: 400px;
  `;

const StyledContainer = styled(Flexer.Child)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${reducedCss}
`;

export default StyledContainer;
